import type { StripeEmbeddedCheckout } from "@stripe/stripe-js";

/**
 * Stripe.js loads only when a visitor opens the memory book's payment. It is
 * strictly necessary for paying, so the tag tells Cookiebot not to block it;
 * `loadStripe` finds the tag and waits for it instead of adding its own.
 */
const STRIPE_JS = "https://js.stripe.com/endive/stripe.js";

function addStripeScript() {
  if (document.querySelector('script[src^="https://js.stripe.com/"]')) {
    return;
  }
  const script = document.createElement("script");
  script.src = STRIPE_JS;
  script.setAttribute("data-cookieconsent", "ignore");
  document.head.appendChild(script);
}

/** Embedded Checkout mounted in `el`; `destroy()` it when the panel closes or changes. */
export async function mountCheckout(
  el: HTMLElement,
  publishableKey: string,
  clientSecret: string
): Promise<StripeEmbeddedCheckout> {
  addStripeScript();
  const { loadStripe } = await import("@stripe/stripe-js");
  const stripe = await loadStripe(publishableKey);
  if (!stripe) {
    throw new Error("Stripe.js did not load");
  }
  const checkout = await stripe.createEmbeddedCheckoutPage({ clientSecret });
  checkout.mount(el);
  return checkout;
}
